import MembroBanca from "../MembroBanca";

export enum VotoCandidato{
  VALIDADO = "Validado",
  NAO_VALIDADO = "Não validado",
  INCONCLUSIVO = "Inconclusivo"
}

export interface Voto {
  id?: string;
  votante?: MembroBanca;
  resultado: VotoCandidato;
  justificativa?: string
  data: Date;
}

class VotoUtils {
  /**
   * Conta a quantidade de votos por resultado.
   * @param votos - Lista de votos.
   * @returns Um objeto com a contagem de cada resultado.
   */
  static contarVotosPorResultado(votos: Voto[]): Record<VotoCandidato, number> {
    return votos.reduce((acc, voto) => {
      acc[voto.resultado] = (acc[voto.resultado] || 0) + 1;
      return acc;
    }, {} as Record<VotoCandidato, number>);
  }

  /**
   * Verifica se um votante já votou.
   * @param votos - Lista de votos.
   * @param votante - Objeto da Pessoa votante.
   * @returns Verdadeiro se o votante já votou, falso caso contrário.
   */
  static votanteJaVotou(votos: Voto[], votante: MembroBanca): boolean {
    return votos.some(voto => voto.votante?.id === votante.id);
  }

  /**
   * Adiciona um novo voto à lista de votos.
   * @param votos - Lista de votos.
   * @param novoVoto - Novo voto a ser adicionado.
   * @returns Lista de votos atualizada.
   */
  static adicionarVoto(votos: Voto[], novoVoto: Voto): Voto[] {
    if (VotoUtils.votanteJaVotou(votos, novoVoto.votante!)) {
      throw new Error(`Votante com ID ${novoVoto.votante?.id} já votou.`);
    }
    return [...votos, novoVoto];
  }

  /**
   * Valida o voto, garantindo que a justificativa está presente quando necessário.
   * @param voto - Objeto do voto.
   * @returns Verdadeiro se o voto for válido, falso caso contrário.
   */
  static validarVoto(voto: Voto): boolean {
    if (voto.resultado === VotoCandidato.NAO_VALIDADO && !voto.justificativa) {
      return false;
    }
    return true;
  }
}

export default VotoUtils;
